
import { computed, defineComponent, reactive, toRefs, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import Checkbox from '@/components/Checkbox.vue'
import Spinner from '@/components/Spinner.vue'
import DatePicker from '@/components/DatePicker/DatePicker.vue'
import { ContactUs } from '@/models/ContactUs'
import {
  countiesList,
  enquiriesList,
  hoursList,
  minsList,
  repliesList,
  servicesList,
  titlesList,
  dynamicallyRules
} from '@/utils/ContactUsRulesAndLists'
import ArrowDropdown from '@/components/vectors/ArrowDropdown.vue'
import ModalLink from '@/components/CMSModalLink.vue'
import Select from '@/components/Select.vue'
import { contactUs } from '@/expressway-api/contactUs.api'
import useSnackbar from '@/composables/useSnackbar'
import TickOutline from '@/components/vectors/TickOutline.vue'

export default defineComponent({
  components: {
    Select,
    ArrowDropdown,
    DatePicker,
    Checkbox,
    Spinner,
    ModalLink,
    TickOutline
  },
  // eslint-disable-next-line max-lines-per-function
  setup () {
    const { setSnackbar } = useSnackbar()
    const state = reactive({
      title: '',
      fullName: '',
      email: '',
      dateOfTravel: '',
      dateOfTravelHour: '',
      dateOfTravelMin: '',
      typeOfService: 'Expressway Services',
      typeOfEnquiry: '',
      from: '',
      to: '',
      routeNo: '',
      details: '',
      likeReply: '',
      contactNumber: '',
      address: '',
      city: '',
      state: '',
      country: '',
      zipcode: '',
      privacyPolicy: false,
      showModal: false,
      loadingContactUsCall: false
    })

    const services = servicesList
    const titles = titlesList
    const enquiries = enquiriesList
    const counties = countiesList
    const replies = repliesList
    const hours = hoursList
    const mins = minsList

    const rules = computed(() => dynamicallyRules(state.likeReply))

    const submitted = ref(false)

    const contactUsCall = async () => {
      const contact: ContactUs = {
        title: state.title,
        name: state.fullName,
        email: state.email,
        travelDateTime: `${state.dateOfTravel} ${state.dateOfTravelHour}:${state.dateOfTravelMin}`,
        serviceType: state.typeOfService,
        enquiryType: state.typeOfEnquiry,
        from: state.from,
        to: state.to,
        routeNo: state.routeNo,
        description: state.details,
        replyWanted: state.likeReply,
        phone: state.contactNumber,
        address: state.address,
        city: state.city,
        letterState: state.state,
        country: state.country,
        post: state.zipcode,
        consent: state.privacyPolicy ? '1' : '0'
      }

      try {
        state.loadingContactUsCall = true
        await contactUs(contact)
        submitted.value = true
        window.scrollTo(0, 0)
        state.loadingContactUsCall = false
      } catch (e) {
        setSnackbar(e.message)
        state.loadingContactUsCall = false
      }
    }

    return {
      v$: useVuelidate(rules, state),
      services,
      titles,
      enquiries,
      counties,
      replies,
      hours,
      mins,
      submitted,
      contactUsCall,
      ...toRefs(state)
    }
  }
})
